export interface Review {
  id: string;
  rating: 1 | 2 | 3 | 4 | 5;
  text: string;
  timeAgo: string;
  imageUrl?: string;
  imageAlt?: string;
}

export const KARROT_SEARCH_URL =
  'https://www.daangn.com/kr/local-profile/s/?in=남현동-350&search=당나귀배송';
